module.exports = __webpack_public_path__ + "static/09_PLATOS-COREA-BIBIMPA-D.6d4f68fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/09_PLATOS-COREA-BIBIMPA-D.png
// module id = 652
// module chunks = 35783957827783